import { saveProfile, type Profile } from "./profile";

let timer: ReturnType<typeof setTimeout> | null = null;

export function persistDebounced(profile: Profile, delayMs = 400): void {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => saveProfile(profile), delayMs);
}

export function exportProfileJson(profile: Profile): string {
  return JSON.stringify(profile, null, 2);
}

export type ImportResult = { ok: true; profile: Profile } | { ok: false; error: string };

export function importProfileJson(json: string): ImportResult {
  let parsed: unknown;
  try {
    parsed = JSON.parse(json);
  } catch {
    return { ok: false, error: "That file isn't valid JSON." };
  }
  if (typeof parsed !== "object" || parsed === null || (parsed as { v?: number }).v !== 2) {
    return { ok: false, error: "Not a recognized Diction Dojo export (expected a v2 profile)." };
  }
  return { ok: true, profile: parsed as Profile };
}
